import * as globalStore from './store'

export function globalModule({store}) {
    store.registerModule('global', {
        ...globalStore,
        namespaced: true,
    })
}